import React, { useState } from "react";
import { Button, Modal, Table, Spin, Typography } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { useUser } from "../../../context/UserContext";
import userService from "../../../services/UserService";

const { Text } = Typography;

const ModalReporteCierres = ({ eventTable, dateRange }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const user = useUser();

  const buildReport = (events, usersList) => {
    const counts = {};
    events.forEach((event) => {
      const userId = event?.stateHistory?.Closed?.userId;
      if (userId) {
        counts[userId] = (counts[userId] || 0) + 1;
      }
    });

    return Object.entries(counts)
      .map(([userId, count]) => {
        const userObj = usersList.find((u) => u.id === userId);
        return {
          userId,
          userName: userObj ? `${userObj.name} ${userObj.lastName}` : "Usuario no encontrado",
          email: userObj?.email || userId,
          count,
        };
      })
      .sort((a, b) => b.count - a.count);
  };

  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    try {
      const response = await userService.consultarUsuarios(user?.idToken || "");
      const usersList = response?.Items || [];
      setReportData(buildReport(eventTable, usersList));
    } catch (err) {
      console.error("Error al obtener usuarios:", err);
      setReportData(buildReport(eventTable, []));
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Usuario",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Eventos cerrados",
      dataIndex: "count",
      key: "count",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.count - b.count,
    },
  ];

  return (
    <>
      <Button icon={<BarChartOutlined />} onClick={handleOpen}>
        Reporte de cierres
      </Button>
      <Modal
        title="Reporte de eventos cerrados por usuario"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={700}
      >
        {dateRange && (
          <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
            Período: {dateRange[0]} — {dateRange[1]}
          </Text>
        )}
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin />
          </div>
        ) : (
          <Table
            dataSource={reportData}
            columns={columns}
            rowKey="userId"
            pagination={false}
            size="small"
            locale={{ emptyText: "Sin eventos cerrados en el período seleccionado" }}
          />
        )}
      </Modal>
    </>
  );
};

export default ModalReporteCierres;
